module.exports = __webpack_public_path__ + "img/personalImg.b54627ca.png";